import { c as _c } from "react/compiler-runtime";
import { CardText } from '@morpho-org/ui-v6/server';
import { ErrorDataUnavailable } from '@/components/common/Error';
const VaultV2ApyError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><ErrorDataUnavailable minHeight="397px" /><CardText className="lg:hidden" height="165px" text="An error has been encountered" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VaultV2ApyError;